// @ts-nocheck
/* eslint-enable */
/* eslint-disable no-undef */

import { getGlobalLogger } from '@zg-rentals/logger-base';

const logger = getGlobalLogger('adTrackingUtils');

/**
 * DataGrail Types
 */
type CookieOption = {
  gtm_key: string;
  isEnabled: boolean;
};

type DataGrailPreferences = {
  consentPreferences: {
    cookieOptions: Array<CookieOption>;
  };
};

/**
 * DataGrail Implementation
 */

/**
 * Disables marketing consent in the given cookie options array.
 */
export const disableMarketingConsent = (cookieOptions: Array<CookieOption>): number => {
  let count = 0;
  for (const option of cookieOptions) {
    // Match both 'marketing' and 'dg-category-marketing' (DataGrail format)
    if ((option.gtm_key === 'marketing' || option.gtm_key === 'dg-category-marketing') && option.isEnabled) {
      option.isEnabled = false;
      count++;
    }
  }

  if (count === 0) {
    logger?.warn('No marketing consent options were disabled', { cookieOptions });
  }

  return count;
};

/**
 * Creates a callback function that disables marketing consent and updates DataGrail preferences.
 */
export const createDenyMarketingCallback = (
  bannerAPI: typeof window.DG_BANNER_API,
  resolve: (value: boolean) => void,
) => {
  return (preferences: DataGrailPreferences) => {
    const { consentPreferences } = preferences;
    const disabledCount = disableMarketingConsent(consentPreferences.cookieOptions);

    try {
      bannerAPI.setConsentPreferences(consentPreferences);
      resolve(true);
    } catch (error) {
      logger?.error('Error setting consent preferences via DataGrail API', { error });
      // Still resolve to avoid blocking the opt-out flow
      resolve(true);
    }
  };
};

/**
 * DataGrail: Opts the user out of marketing tracking
 */
export const setOptOutCookieDataGrail = () => {
  return new Promise((resolve, reject) => {
    if (typeof window === 'undefined' || !window.DG_BANNER_API) {
      const error = { errorCode: '400', errorMsg: '[Cookie] Could not initialize DataGrail' };
      logger?.error('DataGrail API not available', error);
      reject(error);
      return;
    }

    window.dgEvent = window.dgEvent || [];

    const denyMarketing = createDenyMarketingCallback(window.DG_BANNER_API, resolve);

    window.dgEvent.push({
      event: 'initial_preference_callback',
      params: denyMarketing,
    });
  });
};

/**
 * Main export: Opts the user out of marketing tracking using DataGrail
 */
export const setOptOutCookie = () => {
  return setOptOutCookieDataGrail();
};
